<template>
  <div>
    <v-row no-gutters class="mb-6">
      <v-col
        v-for="item in primaryItems"
        :key="item.name"
        cols="12"
        sm="6"
        lg="3"
        class="pr-sm-3 mb-4"
      >
        <v-card class="edit-object-card edit-object-card--primary" :to="item.path">
          <v-icon color="black" left class="edit-object-card__icon">
            {{ item.icon }}
          </v-icon>
          <span>{{ $t(item.name) }}</span>
        </v-card>
      </v-col>
    </v-row>

    <v-card flat class="entity-filter mb-4">
      <v-btn-toggle
        v-model="selectedEntityType"
        mandatory
        dense
        class="entity-filter__toggle"
      >
        <v-btn
          v-for="option in entityTypeOptions"
          :key="option.value"
          :value="option.value"
          small
          text
          class="entity-filter__button"
        >
          {{ option.text }}
        </v-btn>
      </v-btn-toggle>
    </v-card>

    <v-row no-gutters>
      <v-col
        v-for="item in filteredSecondaryItems"
        :key="item.name"
        cols="6"
        md="4"
        class="pr-2 mb-4"
      >
        <v-card class="edit-object-card edit-object-card--secondary" :to="item.path">
          <v-icon color="black" left>{{ item.icon }}</v-icon>
          <span>{{ $t(item.name) }}</span>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
const ENTITY_TYPES = {
  ALL: "all",
  PUBLICATIONS: "publications",
  RESEARCHERS_BUILDING: "researchersBuilding",
  PROJECTS: "projects"
};

export default {
  data() {
    return {
      selectedEntityType: ENTITY_TYPES.ALL,
      primaryItems: [
        {
          name: "section.investigators",
          icon: "accessibility_new",
          path: "/manage/edit/researchers"
        },
        {
          name: "section.publications",
          icon: "menu_book",
          path: "/manage/edit/publications"
        },
        {
          name: "section.projects",
          icon: "mdi-briefcase",
          path: "/manage/edit/projects"
        },
        {
          name: "section.pressNews",
          icon: "mdi-newspaper",
          path: "/manage/edit/pressNews"
        }
      ],
      secondaryItems: [
        {
          name: "section.purchasedLicenses",
          icon: "mdi-license",
          path: "/manage/edit/purchasedLicenses",
          type: ENTITY_TYPES.RESEARCHERS_BUILDING
        },
        {
          name: "section.categories",
          icon: "mdi-tag-multiple",
          path: "/manage/edit/categories",
          type: ENTITY_TYPES.RESEARCHERS_BUILDING
        },
        {
          name: "section.workplaces",
          icon: "mdi-floor-plan",
          path: "/manage/edit/workplaces",
          type: ENTITY_TYPES.RESEARCHERS_BUILDING
        },
        {
          name: "section.services",
          icon: "mdi-wan",
          path: "/manage/edit/services",
          type: ENTITY_TYPES.RESEARCHERS_BUILDING
        },
        {
          name: "section.hosts",
          icon: "mdi-desktop-classic",
          path: "/manage/edit/hosts",
          type: ENTITY_TYPES.RESEARCHERS_BUILDING
        },
        {
          name: "section.journals",
          icon: "mdi-newspaper-variant-multiple-outline",
          path: "/manage/edit/journals",
          type: ENTITY_TYPES.PUBLICATIONS
        },
        {
          name: "section.editorials",
          icon: "mdi-lead-pencil",
          path: "/manage/edit/editorials",
          type: ENTITY_TYPES.PUBLICATIONS
        },
        {
          name: "section.congress",
          icon: "mdi-atlassian",
          path: "/manage/edit/congress",
          type: ENTITY_TYPES.PUBLICATIONS
        },
        {
          name: "section.congressEdition",
          icon: "mdi-artstation",
          path: "/manage/edit/congressEdition",
          type: ENTITY_TYPES.PUBLICATIONS
        },
        {
          name: "section.researchAreas",
          icon: "mdi-chart-arc",
          path: "/manage/edit/researchAreas",
          type: ENTITY_TYPES.PUBLICATIONS
        },
        {
          name: "section.funderPrograms",
          icon: "mdi-desktop-classic",
          path: "/manage/edit/funderPrograms",
          type: ENTITY_TYPES.PROJECTS
        },
        {
          name: "section.organizations",
          icon: "mdi-factory",
          path: "/manage/edit/organizations",
          type: ENTITY_TYPES.PROJECTS
        },
        {
          name: "section.stays",
          icon: "mdi-human-dolly",
          path: "/manage/edit/stays",
          type: ENTITY_TYPES.RESEARCHERS_BUILDING
        },
        {
          name: "section.softwares",
          icon: "mdi-application",
          path: "/manage/edit/softwares",
          type: ENTITY_TYPES.PUBLICATIONS
        },
        {
          name: "section.datasets",
          icon: "mdi-database",
          path: "/manage/edit/datasets",
          type: ENTITY_TYPES.PUBLICATIONS
        },
        {
          name: "section.industrial_property",
          icon: "mdi-rocket-launch",
          path: "/manage/edit/industrialProperties",
          type: ENTITY_TYPES.PUBLICATIONS
        }
      ]
    };
  },
  computed: {
    entityTypeOptions() {
      return [
        {
          text: this.$t("section.entityTypeAll"),
          value: ENTITY_TYPES.ALL
        },
        {
          text: this.$t("section.entityTypePublications"),
          value: ENTITY_TYPES.PUBLICATIONS
        },
        {
          text: this.$t("section.entityTypeResearchersBuilding"),
          value: ENTITY_TYPES.RESEARCHERS_BUILDING
        },
        {
          text: this.$t("section.entityTypeProjects"),
          value: ENTITY_TYPES.PROJECTS
        }
      ];
    },
    filteredSecondaryItems() {
      return this.secondaryItems
        .filter(item => {
          return (
            this.selectedEntityType === ENTITY_TYPES.ALL ||
            item.type === this.selectedEntityType
          );
        })
        .slice()
        .sort((first, second) => {
          return this.$t(first.name).localeCompare(this.$t(second.name));
        });
    }
  },
  methods: {}
};
</script>

<style scoped>
.edit-object-card {
  align-items: center;
  display: flex;
  text-align: left;
}

.edit-object-card--primary {
  font-size: 1.12rem;
  font-weight: 600;
  min-height: 92px;
  padding: 22px 20px;
}

.edit-object-card--primary .edit-object-card__icon {
  font-size: 34px;
  margin-right: 12px;
}

.edit-object-card--secondary {
  min-height: 58px;
  padding: 16px;
}

.entity-filter {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  padding: 10px 12px;
}

.entity-filter__toggle {
  background: transparent !important;
  flex-wrap: wrap;
}

</style>
